"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var locale_settings_html_1 = __importDefault(require("./locale-settings.html"));
(function (module) {
    'use strict';
    function LocaleSettingsController($scope, metricImperial, timezoneUtil, dynamicTranslationHelperUtils) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        $ctrl.isDynamicTranslationsEnabled = dynamicTranslationHelperUtils.isDynamicTranslationsSupported();
        angular.extend($ctrl, {
            timezoneOptions: { searchable: true },
            getUnitItems: function () {
                return metricImperial.getUnitMenu();
            },
            getUnitLabel: function () {
                return metricImperial.getUnitLabel($ctrl.globalOptions.unit, true);
            },
            getTimezoneItems: function () {
                return timezoneUtil.getTimezoneMenu($ctrl.globalOptions.timezone || moment.tz.guess());
            },
            getTimezoneLabel: function () {
                return timezoneUtil.getTimezoneLabel($ctrl.globalOptions.timezone || moment.tz.guess());
            }
        });
    }
    LocaleSettingsController.$inject = [
        '$scope',
        'prMetricImperial',
        'pr.timezoneUtil',
        'prDynamicTranslationsHelperUtils'
    ];
    module.component('prLocaleSettings', {
        templateUrl: locale_settings_html_1.default,
        controller: LocaleSettingsController,
        bindings: {
            globalOptions: '='
        }
    });
})(angular.module('qualtrics.pr'));
